
import {baseURL} from '../httpService/API';
import {hMacAjax} from 'grt-tool-lib-front';

const reqUri = `${baseURL}/grt-user-center-service`;

const uri = {
    // registrationList: `${reqUri}/user/enroll/v1/list`,
    //报名列表赛事报名需求更换接口
    registrationList: `${reqUri}/user/enroll/v2/list`
};

//获取我的报名
export const getRegistrationList = (data) => {
    return hMacAjax.post(uri.registrationList,data);
};

//删除报名
// export const deleteRegistration = (data) => {
//     return hMacAjax.post(url.deleteRegistration,data)
// }